import { Component } from 'react';
import {  Routes, Route, Link } from 'react-router-dom';
import { withRouter } from "./Components/helpers/withRouter";
import './App.css';
import CheckListStep from './Views/CheckListStep';
import CreateCheckList from './Views/CreateCheckList';
import InformationStep from './Views/InformationStep';
import MainAccordion from './Views/MainAccordion';
import PerformTraining from './Views/PerformTraining';
import VideoModelStep from './Views/VideoModelStep';
import SelectTraining from './Views/SelectTraining';
import MediaCapture from './Views/MediaCapture';
import ScrollToTop from './Components/layout/ScrollToTop';
import packageJson from '../package.json';
import {v4 as uuid} from 'uuid';
import {isIncognito, isStorageEphemeral} from './utils/incognitoDetector';

import { openDB } from "idb";
import { Spinner, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import FeedbackModal from './Components/helpers/FeedbackModal';
import { getMimeType } from './utils/extensionHelper';
import { convertCafToWav, convertHeicToPng, convertMovToMp4 } from './utils/fileConverter';
import ToastMessage from './Components/layout/ToastMessage';

import ReactGA from 'react-ga4';
import RouteGuard from './Components/helpers/RouteGuard';
import { BackupContext } from './Components/helpers/BackupProvider';
import { BlobTransferPopup } from './Components/helpers/BlobTransferPopup';
import { faL } from '@fortawesome/free-solid-svg-icons';

export const DB_NAME = "INSTRUCTJS_DB";
export const STORE_NAMES = ["trainings", "media"]; // add as many as you need

const uiModes = ['UI: Step-by-Step', 'UI: Accordion'];

async function initDB() {
  return openDB(DB_NAME, 2, {
    upgrade(db) {
      STORE_NAMES.forEach((storeName) => {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: "id" });
        }
      });
    },
  });
}

export function isGuid(str){
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return guidRegex.test(str);
}

class App extends Component {

  static contextType = BackupContext;

  constructor(props) {
    super(props);

    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-0000000000');

    const storedUiMode = window.localStorage.getItem("uiInUse");
    
    const params = new URLSearchParams(props.location.search);
    const storedTestingMode = params.get("testing");
    const evalMode = !storedTestingMode; //!!params.get('eval-mode');

    this.state = {
      trainingFromParams: params.get('id'),
      evalMode: evalMode, // force this to a boolean. Only true if has value and that value is true
      trainings: [],
      currentTraining: null,
      currentStep: null,
      uiInUse: (uiModes.includes(storedUiMode) && !evalMode) ? storedUiMode : uiModes[1], // default to first mode
      storageEphemeral: false,
      dataPersistanceAlertVisible: false,
      recommendedBroswersAlertVisible: false,
      showTour:false
    };
    window.updateState = this.updateState.bind(this);
    window.getMediaById = this.getMediaById.bind(this);
  }


  restoreUnsubscribe = null;

  async componentDidMount() {
    this.loadTrainingFromParams();
    this.loadTrainings();
    // const incognitoBrowser = await isIncognito();
    const storageEphemeral = await isStorageEphemeral();
    this.setState({ storageEphemeral, dataPersistanceAlertVisible: storageEphemeral, unmounted: false });

    // Subscribe to restore events
    if (this.context && typeof this.context.subscribeToRestore === 'function') {
      this.restoreUnsubscribe = this.context.subscribeToRestore(async () => {
        // Reload trainings when restore occurs
        await this.loadTrainings();
      });
    }
    this.setState({recommendedBroswersAlertVisible: !this.context.supportsFSAccess})

    const {location} = this.props;
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search});
    this.setState({currentPath: location.pathname + location.search});
  }

  async componentWillUnmount(){
    console.log("*** App.componentWillUnmount");
    this.setState({ unmounted: true });
    // Unsubscribe from restore events
    if (this.restoreUnsubscribe) {
      this.restoreUnsubscribe();
    }
  }

  handleCloseIncognitoAlert = () => {
    this.setState({ dataPersistanceAlertVisible: false });
  }

  handleCloseRecommendedBrowsersAlert = () => {
    this.setState({ recommendedBroswersAlertVisible: false });
  }

  componentDidUpdate(prevProps, prevState){
    console.log("*** App.componentDidUpdate, prevState:", prevState, " newState:", this.state);
    const {location} = this.props;
    if(location.pathname + location.search !== this.state.currentPath){
      ReactGA.send({ 
        hitType: "pageview", 
        page: location.pathname + location.search
      });
      this.setState({currentPath: location.pathname + location.search});
    }
    // if (this.state.currentPath && this.state.currentPath.includes('/perform-training') && window.screen && window.screen.orientation) {
    //   window.screen.orientation.lock('landscape').catch(err => {
    //     console.warn('Could not lock orientation:', err);
    //   });
    // }
  }

  async loadTrainingFromParams(){
    // when picking locally, trainings are in C:\inetpub\wwwroot\Files\Public
    if(!this.state.trainingFromParams) return;
    var origin = this.props.location.origin || window.location.origin;
    var serverPath = origin + '/Files/Public/';
    if(serverPath.includes('localhost'))
      serverPath = 'http://localhost/Files/Public/';
    var trainingPath = serverPath + this.state.trainingFromParams + '/' + this.state.trainingFromParams + '.json';
    console.log("Loaded training from params:", this.state.trainingFromParams, " from training path", trainingPath);
    try{
      var response = await fetch(trainingPath, {
        mode: 'cors',
      });
      var training = await response.json();
      if(training){
        //old format of export file
        const db = await initDB();
        for(let i = 0; i < training.Steps.length; ++i){
          const downloadPromises = [];
          training.Steps[i].ImageFilepath = this.fixPath(training.Steps[i].ImageFilepath, training.HomeDirectory, serverPath);
          if(training.Steps[i].ImageFilepath){
            downloadPromises.push(fetch(training.Steps[i].ImageFilepath)
              .then(response => response.blob())
              .then(async (imageFile) =>{
                if (imageFile) {
                  const imageId = uuid();
                  const filename = training.Steps[i].ImageFilepath.split('/').pop();
                  let imageBlob = null; 
                  let mimeType = '';

                  // ✅ Detect and convert HEIC/HEIF files
                  if (/\.heic$/i.test(filename) || /\.heif$/i.test(filename)) {
                    console.log(`Converting ${filename} from HEIC to PNG...`);
                    try {
                      imageBlob = await convertHeicToPng(imageFile, 'png');
                      mimeType = 'image/png';
                    } catch (err) {
                      console.error(`HEIC conversion failed for ${filename}:`, err);
                      training.Steps[i].ImageFilepath = null;
                      return;
                    }
                  }else{
                    mimeType = getMimeType(filename);
                    imageBlob = new Blob([imageFile], { type: mimeType });
                  }

                  const mediaRecord = {
                    id: imageId,
                    file: imageBlob,
                    type: mimeType,
                    date: imageBlob.lastModified ? new Date(imageFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].ImageFilepath = imageId;
                }else{
                  training.Steps[i].ImageFilepath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          training.Steps[i].AudioFilepath = this.fixPath(training.Steps[i].AudioFilepath, training.HomeDirectory, serverPath);
          if(training.Steps[i].AudioFilepath){
            downloadPromises.push(fetch(training.Steps[i].AudioFilepath)
              .then(response => response.blob())
              .then(async (audioFile) => {
                if (audioFile) {
                  const arrayBuffer = await audioFile.arrayBuffer();
                  const header = new TextDecoder().decode(new Uint8Array(arrayBuffer).slice(0, 4));
                  let finalBlob = null;
                  let mimeType = '';

                  // ✅ Detect format
                  if (header === 'caff') {
                    console.warn('CAF detected — converting to WAV...');
                    finalBlob = await convertCafToWav(arrayBuffer);
                    mimeType = 'audio/wav';
                  }else {
                    mimeType = getMimeType(training.Steps[i].AudioFilepath.split('/').pop());
                    finalBlob = new Blob([arrayBuffer], { type: mimeType });
                  }

                  const audioId = uuid();
                  const mediaRecord = {
                    id: audioId,
                    file: finalBlob,
                    type: mimeType,
                    date: audioFile.lastModified ? new Date(audioFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].AudioFilepath = audioId;
                } else {
                  training.Steps[i].AudioFilepath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          training.Steps[i].VideoFilepath = this.fixPath(training.Steps[i].VideoFilepath, training.HomeDirectory, serverPath);
          if(training.Steps[i].VideoFilepath){
            downloadPromises.push(fetch(training.Steps[i].VideoFilepath)
              .then(response => response.blob())
              .then(async (videoFile) => {
                if (videoFile) {
                  const filename = training.Steps[i].VideoFilepath.split('/').pop();
                  let videoBlob = null;
                  let mimeType = '';

                  // ✅ Detect and fix MOV rotation
                  if (/\.mov$/i.test(filename)) {
                    console.log(`Re-encoding ${filename} to fix rotation...`);
                    try {
                      videoBlob = await convertMovToMp4(videoFile);
                      mimeType = 'video/mp4';
                    } catch (err) {
                      console.error(`MOV conversion failed for ${filename}:`, err);
                      training.Steps[i].VideoFilepath = null;
                      return;
                    }
                  }else{
                    mimeType = getMimeType(filename);
                    videoBlob = new Blob([videoFile], { type: mimeType });
                  }

                  const videoId = uuid();
                  const mediaRecord = {
                    id: videoId,
                    file: videoBlob,
                    type: mimeType,
                    date: videoFile.lastModified ? new Date(videoFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].VideoFilepath = videoId;
                }else{
                  training.Steps[i].VideoFilepath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          training.Steps[i].ContentImagePath = this.fixPath(training.Steps[i].ContentImagePath, training.HomeDirectory, serverPath);
          if(training.Steps[i].ContentImagePath){
            downloadPromises.push(fetch(training.Steps[i].ContentImagePath)
              .then(response => response.blob())
              .then(async (imageFile) => {
                if (imageFile) {
                  const imageId = uuid();
                  const filename = training.Steps[i].ContentImagePath.split('/').pop();
                  let imageBlob = null; 
                  let mimeType = '';

                  // ✅ Detect and convert HEIC/HEIF files
                  if (/\.heic$/i.test(filename) || /\.heif$/i.test(filename)) {
                    console.log(`Converting ${filename} from HEIC to PNG...`);
                    try {
                      imageBlob = await convertHeicToPng(imageFile, 'png');
                      mimeType = 'image/png';
                    } catch (err) {
                      console.error(`HEIC conversion failed for ${filename}:`, err);
                      training.Steps[i].ImageFilepath = null;
                      return;
                    }
                  }else{
                    mimeType = getMimeType(filename);
                    imageBlob = new Blob([imageFile], { type: mimeType });
                  }                  
                  const mediaRecord = {
                    id: imageId,
                    file: imageBlob,
                    type: mimeType,
                    date: imageFile.lastModified ? new Date(imageFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].ContentImagePath = imageId;
                }else{
                  training.Steps[i].ContentImagePath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          const total = downloadPromises.length;
          const totalSteps = training.Steps.length;
          let completed = 0;
          let curStep = i + 1;
          this.setState({ downloadProgress: { completed, total, curStep, totalSteps } });
          const wrappedPromises = downloadPromises.map(p =>
            p.then((result) => {
              completed += 1;
              this.setState({ downloadProgress: { completed, total, curStep, totalSteps } });
              return result;
            })
          );

          await Promise.all(wrappedPromises);
        }
        training.CheckList = training.Steps?.find(s => s.Index === 0)?.Training?.CheckList?.filter(item => item.Step !== "Preview Checklist" && item.Step !== "Review Checklist") || [];
        console.log("Setting currentTraining from params:", this.state.trainingFromParams, " to", training);
        this.setState({      
          // trainings: [...prev.trainings, training],
          currentTraining: training,
          currentStep: null
        }, () => {
          console.log('Opened training:', training.Title);
          const curURL = new URL(window.location.href);
          this.props.navigate({
            pathname: '/perform-training',
            search: curURL.search
        });
        });

      }else{
        trainingPath = serverPath + this.state.trainingFromParams + '/' + this.state.trainingFromParams + '.zip';
        var response = await fetch(trainingPath, {
          mode: 'cors',
        });
        if(response.ok){
          const JSZip = (await import('jszip')).default;
          const zip = await JSZip.loadAsync(response.blob());
          const jsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
          await this.importZipFile(zip, jsonFile, true);
        }
      }
    }catch(error){
      console.error(error);
      try{
        trainingPath = serverPath + this.state.trainingFromParams + '/' + this.state.trainingFromParams + '.zip';
        var response = await fetch(trainingPath, {
          mode: 'cors',
        });
        if(response.ok){
          const JSZip = (await import('jszip')).default;
          const zip = await JSZip.loadAsync(response.blob());
          const jsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
          await this.importZipFile(zip, jsonFile, true);
        }
      }catch(err){
        console.error(err);
      }
    }
  }

  fixPath(wholePath, homeDirectory, newHomeLocation){
    if(wholePath){
      var relativePath = wholePath.slice(wholePath.indexOf(homeDirectory));
      var newPath = newHomeLocation + relativePath;
      return newPath;
    }
    return wholePath;
  }

  async loadTrainings() {
    if(this.state.unmounted){ return; }
    const db = await initDB();
    const storeName = STORE_NAMES[0]; // first one in the list
    const trainings = await db.getAll(storeName);
    // if(trainings){
    console.log("Loaded trainings from IndexedDB:", trainings);
    this.setState(
      {
        trainings, 
        trainingsLoaded: true
      }, 
      () => {
        this.removeExtraMedia();
      }
    );
    // }
  }

  async removeExtraMedia(){
    if(!this.state.trainingsLoaded){ return; }
    const curTrainings = [...this.state.trainings.map(t => t.Id), this.state.trainingFromParams];
    const db = await initDB();
    const mediaItems = db.getAll(STORE_NAMES[1]);
    for(const media in mediaItems)
    {
      if(media.trainings && media.trainings.length > 0 && !media.trainings.some(t => curTrainings.has(t))){
        db.delete(STORE_NAMES[1], media.Id);
      }
    }
  }

  updateState(stateUpdate, callback){
    const prevState = this.state;
    this.setState(stateUpdate, async () => {
      // resolve the new state (if stateUpdate was a function, use this.state after setState)
      const newState = this.state;
      console.log("State updated. Old state:", prevState, " New state:", newState);
      
      // Store uiInUse in localStorage if it changed
      if (newState.uiInUse !== prevState.uiInUse) {
        window.localStorage.setItem("uiInUse", newState.uiInUse);
      }
      
      const db = await initDB();

          // figure out which keys were updated
      const updatedKeys =
        typeof stateUpdate === "function"
          ? Object.keys(stateUpdate(newState, this.props) || {})
          : Object.keys(stateUpdate || {});
      console.log("Updated keys:", updatedKeys);

      if(updatedKeys.includes("currentTraining") && newState.currentTraining) {
        console.log("updating currentTraining: ", newState.currentTraining);
        await db.put(STORE_NAMES[0], newState.currentTraining);
        this.context.scheduleSnapshot(); // take backup snapshot after updating training
      }
      if (updatedKeys.includes("currentStep") && newState.currentStep) {
        console.log("updating currentStep: ", newState.currentStep);
        let steps = newState.currentTraining.Steps ?? [];
        const idx = steps.findIndex(s => s.id === newState.currentStep.id);

        if (idx >= 0) {
          // update existing step
          steps[idx] = { ...steps[idx], ...newState.currentStep };
        } else {
          console.log("Saving training with new step: ", newState.currentStep, " to list of steps: ", steps);
          // add step if it doesn’t exist
          steps = steps.map(step =>
            step.Index >= newState.currentStep.Index
              ? { ...step, Index: step.Index + 1 }
              : step
          );
          steps = [...steps, newState.currentStep];
        }

        steps.sort((a, b) => a.Index - b.Index);
        steps.forEach((step, index) => {step.Index = index;})
        newState.currentTraining.Steps = steps;

        console.log("Saving training with updated Steps:", newState.currentTraining);
        await db.put(STORE_NAMES[0], newState.currentTraining);
        this.context.scheduleSnapshot(); // take backup snapshot after updating training
      }
      if(updatedKeys.includes("trainings")) {
        console.log("updating trainings: ", newState.trainings);
        const toDelete = prevState.trainings.filter(t => !newState.trainings.some(nt => nt.Id === t.Id));        
        const toAdd = newState.trainings.filter(t => !prevState.trainings.some(pt => pt.Id === t.Id));
        const getSnapshot = toAdd.length > 0 || toDelete.length > 0;
        if(toAdd.length > 0) {
          console.log("Adding trainings to DB:", toAdd);
          for (const training of toAdd) {
            await db.put(STORE_NAMES[0], training);
          }
        }
        if(toDelete.length > 0) {
          console.log("Deleting trainings from DB that were removed from state:", toDelete);
          for (const training of toDelete) {
            await db.delete(STORE_NAMES[0], training.id);
          }
        }
        if(getSnapshot)
          this.context.scheduleSnapshot(); // take backup snapshot after updating trainings
      }
      if(updatedKeys.includes('tempMessage')){
        if(newState.tempMessage){
          if(newState.tempMessageTimeoutId)
            clearTimeout(newState.tempMessageTimeoutId)
          if(newState.tempMessage && !(newState.tempMessage.duration < 0)){
            this.setState({tempMessageTimeoutId: setTimeout(() => {
                this.setState({tempMessage: null});
                clearTimeout(this.state.tempMessageTimeoutId)
              }, newState.tempMessage.duration ?? 5000)
            });
          }
        }else{
          this.setState({tempMessageTimeoutId: null});
        }
      }
      this.loadTrainings();
      if(callback) callback();
    });
  }

  getMediaById = async (media) => {
    return new Promise((resolve, reject) => {
      if(!media){
        resolve(null);
        return;
      }
      if(!isGuid(media)){
        resolve(media);
        return;
      }

      const request = indexedDB.open(DB_NAME);

      request.onsuccess = function (event) {
        const db = event.target.result;
        const transaction = db.transaction(STORE_NAMES[1], "readonly");
        const store = transaction.objectStore(STORE_NAMES[1]);

        const getRequest = store.get(media); // looks up by primary key

        getRequest.onsuccess = function () {
          resolve(getRequest.result); // null if not found
        };

        getRequest.onerror = function () {
          reject(getRequest.error);
        };
      };

      request.onerror = function () {
        reject(request.error);
      };
    });
  }

  getMediaForTraining = async (trainingId) => {
    const db = await initDB();
    const allMedia = await db.getAll(STORE_NAMES[1]);
    return allMedia.filter(m => m.trainings?.includes(trainingId));
  }

  handleImport = async (blob) => {
    // Try to parse as JSON first
    try {
      const text = await blob.text();
      const data = JSON.parse(text);
      if (data.Training || data.training) {
        // It's a JSON export file
        const file = new File([blob], 'import.json', { type: 'application/json' });
        await this.importJsonFile(file);
        alert('Import successful!');
        return;
      }
    } catch (e) {
      // Not JSON, proceed to try ZIP
    }

    // Try to load as ZIP
    try {
      const JSZip = (await import('jszip')).default;
      const zip = await JSZip.loadAsync(blob);
      const jsonFile = Object.keys(zip.files).find(name => name.endsWith('_export.json'));
      if (jsonFile) {
        if(await this.importZipFile(zip, jsonFile)){
          alert('Import successful!');
        }
        return;
      }
      const oldJsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
      if (oldJsonFile) {
        if(await this.importMauiExport(zip, oldJsonFile)){
          alert('Import successful!');
        }
        return;
      }
      alert('No valid export file found in ZIP.');
    } catch (e) {
      alert('Invalid file format. Please ensure the file is a valid JSON or ZIP export.');
    }
  }

  importJsonFile = async (file) => {
    // Import from JSON
    const text = await file.text();
    let exportData;
    try {
      exportData = JSON.parse(text);
    } catch {
      // Try to parse legacy format
      exportData = JSON.parse(text.replace(/^"Training":/, '{ "Training":').replace(/"Media Files":/, '"Media Files":'));
    }
    const importedTraining = exportData.Training || exportData.training;
    if (importedTraining) {
      if (this.state.trainings.find(t => t.Id === importedTraining.Id)) {
        alert('Training with this ID already exists.');
        return false;
      }
      importedTraining.id = this.state.trainings.length > 0 ? Math.max(...this.state.trainings.map(t => t.id)) + 1 : 1;
      window.updateState({currentTraining: importedTraining});
      return true;
    }else{
      alert('Invalid export file.');
      return false;
    }
  }

  importZipFile = async (zip, jsonFile, temporary) => {
    const jsonStr = await zip.file(jsonFile).async('string');
    const exportData = JSON.parse(jsonStr);

    // Add training
    const importedTraining = exportData.Training || exportData.training;
    // if (this.state.trainings.find(t => t.Id === importedTraining.Id)) {
    //   alert('Training with this ID already exists.');
    //   return false;
    // }
    importedTraining.id = this.state.trainings.length > 0 ? Math.max(...this.state.trainings.map(t => t.id)) + 1 : 1;
    if(temporary){
      importedTraining.HomeDirectory = this.state.trainingFromParams;
      this.setState({      
        currentTraining: importedTraining
      });
    }else{
      this.setState((prev) => ({
        trainings: [...prev.trainings, importedTraining]
      }));
    }

    // Add media files
    const mediaFiles = exportData["Media Files"] || exportData["mediaFiles"] || [];
    if (mediaFiles && mediaFiles.length > 0) {
      const db = await initDB();
      for (const mediaMeta of mediaFiles) {
        var existing = await this.getMediaById(mediaMeta.id);
        if(existing){
          if (!existing.trainings) {
            existing.trainings = [];
          }
          if (!existing.trainings.includes(importedTraining.Id)) {
            existing.trainings.push(importedTraining.Id);
            await db.put(STORE_NAMES[1], existing);
          }
        }else{
          const mediaBlob = await zip.file(mediaMeta.id).async('blob');
          // Save to DB using your existing method
          const mediaRecord = { ...mediaMeta, file: mediaBlob };
          await db.add(STORE_NAMES[1], mediaRecord);
        }
      }
    }
    return true;
  }

  importMauiExport = async (zip, jsonFile, temporary) => {
    const jsonStr = await zip.file(jsonFile).async('string');
    var importedTraining = JSON.parse(jsonStr);
    // Add training
    if (this.state.trainings.find(t => t.Id === importedTraining.Id)) {
      alert('Training with this ID already exists.');
      return false;
    }

    const db = await initDB();
    for(const step of importedTraining.Steps){
      if(step.AudioFilepath){
        const audioFilename = step.AudioFilepath.split('/').pop();
        const audioFileInZip = Object.keys(zip.files).find(name => name.endsWith(audioFilename));
        if (audioFileInZip) {
          const audioFile = await zip.file(audioFileInZip);
          // Read the file as ArrayBuffer so we can inspect the header
          const arrayBuffer = await audioFile.async('arraybuffer');
          const header = new TextDecoder().decode(new Uint8Array(arrayBuffer).slice(0, 4));
          
          let audioBlob = null;
          let mimeType = '';

          // ✅ Detect format
          if (header === 'caff') {
            console.warn('CAF detected — converting to WAV...');
            audioBlob = await convertCafToWav(arrayBuffer);
            mimeType = 'audio/wav';
          }else {
            mimeType = getMimeType(audioFilename);
            audioBlob = new Blob([arrayBuffer], { type: mimeType });
          }

          const audioId = uuid();
          const mediaRecord = {
            id: audioId, 
            file: audioBlob, 
            type: audioBlob.type, 
            date: audioFile.lastModified ? new Date(audioFile.lastModified) : new Date(), 
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.AudioFilepath = audioId;
        }else{
          step.AudioFilepath = null; // clear invalid reference
        }
      }
      if(step.VideoFilepath){
        const videoFilename = step.VideoFilepath.split('/').pop();
        const videoFileInZip = Object.keys(zip.files).find(name => name.endsWith(videoFilename));
        if (videoFileInZip) {
          const videoFile = await zip.file(videoFileInZip);
          const rawBlob = await videoFile.async('blob');
          let videoBlob = null;
          let mimeType = '';

          if (/\.mov$/i.test(videoFilename)) {
            console.log(`Re-encoding ${videoFilename} to fix rotation...`);
            try {
              videoBlob = await convertMovToMp4(rawBlob);
              mimeType = 'video/mp4';
            } catch (err) {
              console.error(`MOV conversion failed for ${videoFilename}:`, err);
              step.VideoFilepath = null;
              return;
            }
          }else{
            mimeType = getMimeType(videoFilename);
            videoBlob = new Blob([rawBlob], { type: mimeType });
          }

          const videoId = uuid();
          const mediaRecord = {
            id: videoId,
            file: videoBlob,
            type: videoBlob.type,
            date: videoFile.lastModified ? new Date(videoFile.lastModified) : new Date(),
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.VideoFilepath = videoId;
        }else{
          step.VideoFilepath = null; // clear invalid reference
        }
      }
      if(step.ImageFilepath){
        const imageFilename = step.ImageFilepath.split('/').pop();
        const imageFileInZip = Object.keys(zip.files).find(name => name.endsWith(imageFilename));
        if (imageFileInZip) {
          const imageFile = await zip.file(imageFileInZip);
          const rawBlob = await imageFile.async('blob');
          let imageBlob = null;
          let mimeType = '';

          // ✅ Convert HEIC/HEIF files using ffmpeg.wasm (v0.11+)
          if (/\.heic$/i.test(imageFilename) || /\.heif$/i.test(imageFilename)) {
            console.log(`Converting ${imageFilename} from HEIC to PNG...`);
            try {
              imageBlob = await convertHeicToPng(rawBlob, 'png');
              mimeType = 'image/png';
            } catch (err) {
              console.error(`HEIC conversion failed for ${imageFilename}:`, err);
              step.ImageFilepath = null;
              return;
            }
          }else{
            mimeType = getMimeType(imageFilename);
            imageBlob = new Blob([rawBlob], { type: mimeType });
          }

          const imageId = uuid();
          const mediaRecord = {
            id: imageId,
            file: imageBlob,
            type: imageBlob.type,
            date: imageFile.lastModified ? new Date(imageFile.lastModified) : new Date(),
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.ImageFilepath = imageId;
        }else{
          step.ImageFilepath = null; // clear invalid reference
        }
      }
      if(step.ContentImagePath){
        const imageFilename = step.ContentImagePath.split('/').pop();
        const imageFileInZip = Object.keys(zip.files).find(name => name.endsWith(imageFilename));
        if (imageFileInZip) {
          const imageFile = await zip.file(imageFileInZip);
          const rawBlob = await imageFile.async('blob');
          let imageBlob = null;
          let mimeType = '';

          // ✅ Convert HEIC/HEIF files using ffmpeg.wasm (v0.11+)
          if (/\.heic$/i.test(imageFilename) || /\.heif$/i.test(imageFilename)) {
            console.log(`Converting ${imageFilename} from HEIC to PNG...`);
            try {
              imageBlob = await convertHeicToPng(rawBlob, 'png');
              mimeType = 'image/png';
            } catch (err) {
              console.error(`HEIC conversion failed for ${imageFilename}:`, err);
              step.ImageFilepath = null;
              return;
            }
          }else{
            mimeType = getMimeType(imageFilename);
            imageBlob = new Blob([rawBlob], { type: mimeType });
          }

          const imageId = uuid();
          const mediaRecord = {
            id: imageId,
            file: imageBlob,
            type: imageBlob.type || 'image/png',
            date: imageFile.lastModified ? new Date(imageFile.lastModified) : new Date(),
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.ContentImagePath = imageId;
        }else{
          step.ContentImagePath = null; // clear invalid reference
        }
      }
    }
    importedTraining.id = this.state.trainings.length > 0 ? Math.max(...this.state.trainings.map(t => t.id)) + 1 : 1;
    importedTraining.CheckList = importedTraining.Steps?.find(s => s.Index === 0)?.Training?.CheckList?.filter(item => item.Step !== "Preview Checklist" && item.Step !== "Review Checklist") || [];
    if(temporary){
      this.setState({      
        currentTraining: importedTraining
      });
      return true;
    }
    this.setState((prev) => ({
      trainings: [...prev.trainings, importedTraining]
    }));
    return true;
  }

  // importTraining = async (event) => {
  //   // ...existing code...
  //   const file = event.target.files[0];
  //   if (!file) return;
  importTraining = async (file) => {
    // Check if it's a zip or json
    if (file.name.endsWith('.zip')) {
      // Import from zip
      const JSZip = (await import('jszip')).default;
      const zip = await JSZip.loadAsync(file);

      // Find the JSON file in the zip
      const jsonFile = Object.keys(zip.files).find(name => name.endsWith('_export.json'));
      if (jsonFile) {
        if(await this.importZipFile(zip, jsonFile)){
          alert('Import successful!');
        }
      }else{
        const oldJsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
        if(!oldJsonFile){
          alert('No export JSON found in zip.');
          return;
        }
        if(await this.importMauiExport(zip, oldJsonFile)){
          alert('Import successful!');
        }
      }
    } else if (file.name.endsWith('.json')) {
      if(await this.importJsonFile(file)){
        alert('Import successful!');
      }
    } else {
      alert('Unsupported file type.');
    }
    this.setState({ showImportModal: false });
    // Reset file input so user can import again
    // event.target.value = '';
  }

  render() {
    const {location} =this.props;
    console.log("Rendering:", this.state, " with location", location);
    console.log("App Routes:", Routes);

    const showLoadingModal = this.state.trainingFromParams && this.state.currentTraining?.HomeDirectory !== this.state.trainingFromParams;
    let linkState = 2;
    if(!this.state.trainingFromParams){
      if(location.pathname === '/')
        linkState = 0;
      else if(!this.state.trainingFromParams && location.pathname !== '/camera')
        linkState = 1;
    }

    return (
      <div className='instruct-display-bars'>
      <div className='instruct_background'>
      <ScrollToTop/>
      <div className="App">
        <header className="App-header">
          {this.state.tempMessage && 
          <ToastMessage
            showToast = {!!this.state.tempMessage}
            icon = {this.state.tempMessage.icon}
            title = {this.state.tempMessage.title}
            label = {this.state.tempMessage.label}
            message = {this.state.tempMessage.message}
          />}
          {this.state.dataPersistanceAlertVisible && (
            <Alert color="warning" style={{fontSize: '.75em'}} toggle={this.handleCloseIncognitoAlert}>
              <p className='mb-1'>
                <strong>Data may not persist in this browser session.</strong>
              </p>
              <p className='mb-1'>
                Your training data and media files are stored locally and may be cleared
                when this tab or browser is closed.
              </p>
              <p className='mb-0'>
                To avoid losing you work, please export your training or download a backup before leaving,
                or use a browser session that supports persistent storage.
              </p>
              <p className='mb-0'>
                We recommend using Chrome, Edge, or another Chromium-based browser for best storage support.
              </p>

            </Alert>
          )}
          {this.state.recommendedBroswersAlertVisible && (
            <Alert color="warning" style={{fontSize: '.75em'}} toggle={this.handleCloseRecommendedBrowsersAlert}>
              <p className='mb-1'>
                For best performance and full functionality, we recommend using Chrome, Edge, or another Chromium-based browser.
              </p>
              <p className='mb-1'>
                Some features may not work properly in other browsers. More information about browser support can be found in the Help section.
              </p>
            </Alert>
          )}
          {!this.state.trainingFromParams && (
            <div className='App-title' style={{ marginBottom: '1em', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '0.5em' }}>
              <img
                src={process.env.PUBLIC_URL + '/INSTRUCT.ico'}
                alt="App Icon"
                style={{ width: 64, height: 64, marginRight: 4 }}
              />
              <div>INSTRUCT</div>
            </div>
          )}
          {/* <Alert color="warning" style={{fontSize: '.75em'}}>This site is currently under development</Alert> */}
          <nav className='function-bar' style={{ display: 'flex', justifyContent: 'space-between', width: '95%' }}>
            <span style={{marginLeft: 'auto', textAlign: "right" }}>
              {linkState === 0 &&
                <>
                  {!this.state.evalMode && (
                    <Link
                      className="App-link"
                      to="#"
                      onClick={e => {
                        e.preventDefault();
                        const currentIdx = uiModes.indexOf(this.state.uiInUse);
                        const nextIdx = (currentIdx + 1) % uiModes.length;
                        this.updateState({ uiInUse: uiModes[nextIdx] });
                      }}
                    >
                    {this.state.uiInUse}
                    </Link>
                  )}
                  {!this.state.evalMode && ' | '}
                  {!this.context.hasBackupFile && (
                      <Link
                      className="App-link"
                      to="#"
                      onClick={e => {
                        this.context.chooseBackupFile(true);
                      }}
                    >
                    Choose Backup File
                    </Link>
                  )}
                  {!this.context.hasBackupFile && ' | '}
                  {/* {this.context.hasBackupFile && this.context.supportsFSAccess && (
                    <Link
                      className="App-link"
                      to="#"
                      onClick={e => {
                        this.context.closeBackupFile();
                      }}
                    >
                    Close Backup File
                    </Link>
                  )}
                  {this.context.hasBackupFile &&  this.context.supportsFSAccess &&  ' | '} */}
                  {!this.context.hasBackupFile && this.context.supportsFSAccess && (
                    <Link
                      className="App-link"
                      to="#"
                      onClick={e => {
                        this.context.chooseBackupFile(false);
                      }}
                    >
                    Create Backup File
                    </Link>
                  )}
                  {!this.context.hasBackupFile &&  this.context.supportsFSAccess &&  ' | '}
                  <Link className="App-link" 
                    to="#"
                    onClick={e =>{
                      // e.preventDefault();
                      // window.alert(
                      //   'Importing a training will add new content to your app created using the INSTRUCT Platform. These trainings may be either json or zip files. If a training with the same ID already exists, it will not be overwritten.\n\nPlease ensure you trust the source of the file. Click OK to continue.'
                      // );
                      // this.fileInputRef && this.fileInputRef.click();
                      this.setState({ showBlobTransferPopup: true });
                    }}
                  >
                    Import Training
                  </Link>
                  {/* <input
                    type="file"
                    accept=".json,.zip"
                    ref={ref => (this.fileInputRef = ref)}
                    style={{ display: "none" }}
                    onChange={this.importTraining}
                  /> */}
                  {' | '}
                </>
              }
              {linkState === 1 && 
                <>
                  <Link className="App-link" style={{textAlign: "left" }} to={{ pathname: "/", search: this.props.location?.search || "" }}>Home</Link> 
                  {' | '}
                </>
              }
              {/* {this.context.undoAvailable && (
                <Link
                  className="App-link"
                  to="#"
                  onClick={e => {
                    this.context.undo();
                  }}
                >
                Undo
                </Link>
              )}
              {this.context.undoAvailable && ' | '}
              {this.context.redoAvailable && (
                <Link
                  className="App-link"
                  to="#"
                  onClick={e => {
                    this.context.redo();
                  }}
                >
                Redo
                </Link>
              )}
              {this.context.redoAvailable && ' | '} */}
              {(linkState === 0 || linkState === 1) && !this.context.supportsFSAccess && (
                <Link
                  className="App-link"
                  to="#"
                  onClick={e => {
                    this.context.writeHistoryFileFirefox();
                  }}
                >
                Download Backup
                </Link>
              )}
              {(linkState === 0 || linkState === 1) && !this.context.supportsFSAccess && ' | '}
              <Link 
                className="App-link" 
                style={{marginLeft: "auto", textAlign: "right" }} 
                to="#"
                onClick={e => {
                  e.preventDefault();
                  this.updateState({ showTour: true });
                }}>
                  Help
              </Link>
            </span>             
          </nav>

          {showLoadingModal && (
            <Modal isOpen={true} centered={true}>
              <ModalHeader>Loading Training</ModalHeader>
              <ModalBody>
                <div className="text-center">
                  <Spinner>Loading...</Spinner>
                </div>
                <p>Content for the selected training is being downloaded.</p>
                {this.state.downloadProgress && (
                  <span>
                    Step {this.state.downloadProgress.curStep} of {this.state.downloadProgress.totalSteps}: {this.state.downloadProgress.completed} of {this.state.downloadProgress.total} files imported.
                  </span>
                )}
              </ModalBody>
            </Modal>
          )}
          <BlobTransferPopup
            isOpen={this.state.showBlobTransferPopup}
            onClose={() => this.setState({ showBlobTransferPopup: false })}
            onBlobReceived={(blob) => this.handleImport(blob)}
            onFileReceived={(file) => this.importTraining(file)}
            mode={"receiver"}
          />
          {/* <RouteGuard
            currentTraining={this.state.currentTraining}
            trainingFromParams={this.state.trainingFromParams}
          > */}
            <Routes>
              <Route
                path="/"
                element={
                  <SelectTraining 
                    trainings={this.state.trainings}
                    updateState={window.updateState}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    getMediaForTraining={this.getMediaForTraining}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                    onBlobReceived={(blob) => this.handleImport(blob)}
                  />
                }
              />
              <Route
                path="/checklist-step"
                element={
                  <CheckListStep 
                    currentTraining={this.state.currentTraining} 
                    currentStep={this.state.currentStep}
                    updateState={window.updateState}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
              <Route
                path="/create-checklist"
                element={
                  <CreateCheckList 
                    currentTraining={this.state.currentTraining} 
                    updateState={window.updateState}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
              <Route
                path="/information-step"
                element={
                  <InformationStep 
                    currentTraining={this.state.currentTraining} 
                    currentStep={this.state.currentStep} 
                    updateState={window.updateState}
                    getMediaById={window.getMediaById}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
              <Route
                path="/main-accordion"
                element={
                  <MainAccordion 
                    currentTraining={this.state.currentTraining} 
                    currentStep={this.state.currentStep}
                    AudioRecorder={window.recorderRef}
                    updateState={window.updateState} 
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
              <Route
                path="/perform-training"
                element={
                  <PerformTraining 
                    currentTraining={this.state.currentTraining} 
                    updateState={window.updateState} 
                    getMediaById={window.getMediaById}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
              <Route
                path="/video-model-step"
                element={
                  <VideoModelStep 
                    currentTraining={this.state.currentTraining} 
                    currentStep={this.state.currentStep} 
                    updateState={window.updateState}
                    getMediaById={window.getMediaById}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
              <Route
                path="/camera"
                element={
                  <MediaCapture 
                    currentTraining={this.state.currentTraining} 
                    currentStep={this.state.currentStep}
                    updateState={window.updateState}
                    uiInUse={this.state.uiInUse}
                    evalMode={this.state.evalMode}
                    showTour={this.state.showTour}
                    incognitoBrowser={this.state.incognitoBrowser}
                    supportsFSAccess={this.context.supportsFSAccess}
                  />
                }
              />
            </Routes>
          {/* </RouteGuard> */}
          {!this.state.trainingFromParams && <div className='App-footer' style={{  marginBottom: '1em', fontWeight: "bold", fontSize: '.75em'}}>
            <div>v{packageJson.version}</div>
            <div>
              <Link
                className="App-link"
                to="#"
                  onClick={() => this.setState({ showFeedbackModal: true })}
                >
                  Provide Feedback
              </Link>
              {' | '}
              <Link
                className="App-link"
                to="#"
                onClick={e => {
                  e.preventDefault();
                  this.setState({ showFundingModal: true });
                }}
              >
                Funding Disclosure
              </Link>
              {' | '}
              <Link
                className="App-link"
                to="#"
                onClick={e => {
                  e.preventDefault();
                  this.setState({ showPrivacyModal: true });
                }}
              >
                Privacy Policy
              </Link>

            </div>
            <FeedbackModal
              isOpen={!!this.state.showFeedbackModal}
              onClose={() => this.setState({ showFeedbackModal: false })}
            />
            <Modal isOpen={!!this.state.showFundingModal} toggle={() => this.setState({ showFundingModal: false })} centered={true}>
              <ModalHeader toggle={() => this.setState({ showFundingModal: false })}>Funding Disclosure</ModalHeader>
              <ModalBody>
                <p>
                  The contents of this website were developed under a grant from the National Institute on Disability, Independent Living, and Rehabilitation Research (NIDILRR grant number 90REGE0014) to the Rehabilitation Engineering Research Center on Augmentative and Alternative Communication (RERC on AAC). NIDILRR is a Center within the Administration for Community Living (ACL), Department of Health and Human Services (HHS). The contents of this website do not necessarily represent the policy of NIDILRR, ACL, or HHS, and you should not assume endorsement by the Federal Government.                  
                </p>
              </ModalBody>
            </Modal>
            <Modal isOpen={!!this.state.showPrivacyModal} toggle={() => this.setState({ showPrivacyModal: false })} centered={true}>
              <ModalHeader toggle={() => this.setState({ showPrivacyModal: false })}>Privacy Policy</ModalHeader>
              <ModalBody>
                <p>
                  <strong>Data Privacy Notice</strong><br/>
                  This application stores all training data and media files locally in your browser using IndexedDB. No personal data is sent to any external server or third party. Your data remains private and under your control at all times.<br/><br/>
                  You do have the option to create backup files or export your training data, which will be saved to your device. These files are not shared with us or anyone else unless you choose to share them. For more information on using the backup feature, please click Help from the Home Screen.<br/><br/>
                  If you choose to export or import specific trainings, files are handled entirely on your device. Please ensure you trust the source of any imported files.<br/><br/>
                  For questions or concerns about privacy, contact us at <a href="mailto:admin@instruct.aac-learning-center.org">admin@instruct.aac-learning-center.org</a>.
                </p>
              </ModalBody>
            </Modal>
          </div>}
        </header>
      </div>
    </div>
    </div>
    );
  }
}

export default withRouter(App);